// removed by extract-text-webpack-plugin
module.exports = {"buttonMedium":"index-buttonMedium-A89nc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/mobile-button/index.less
// module id = 802
// module chunks = 0